export default "__VITE_ASSET__BG2$SV$c__"